export const OCC_ENDPOINTS = {
  wishlistAll: 'current-user/wishlist',
  wishlist: 'current-user/wishlist/${productCode}',
};
